import { useState, useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Hook to detect whether the app is running on a native platform (Android/iOS)
 * or in a web browser. This allows conditional routing between Capacitor native
 * plugins and standard Web APIs.
 */
export const useNativePlatform = () => {
  const [platformInfo] = useState(() => {
    const isNative = Capacitor.isNativePlatform();
    const platform = Capacitor.getPlatform(); // 'web' | 'android' | 'ios'

    return {
      isNative,
      isWeb: !isNative,
      isAndroid: platform === 'android',
      isIos: platform === 'ios',
      platform,
    };
  });

  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    if (platformInfo.isNative) {
      setIsMobileDevice(true);
    } else {
      const ua = (navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();
      setIsMobileDevice(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua));
    }
  }, [platformInfo.isNative]);

  return {
    ...platformInfo,
    isMobileDevice,
  };
};

/**
 * Non-hook utility for synchronous platform checks outside React components.
 */
export const getPlatformInfo = () => {
  const isNative = Capacitor.isNativePlatform();
  const platform = Capacitor.getPlatform();

  return {
    isNative,
    isWeb: !isNative,
    isAndroid: platform === 'android',
    isIos: platform === 'ios',
    platform,
  };
};
